/* eslint-disable indent */
/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/order */
import 'antd/dist/antd.css';

import {
  Box,
  Button,
  Card,
  Dialog,
  Form,
  Input,
  Message,
  NumberPicker,
  Pagination,
  Table,
  TimePicker,
} from '@alifd/next';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import { getVisitorEntryTime } from '@/helpers/getVisitorEntryTime';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const VisitorAccessStatisticsList = () => {
  const visitorAppointmentRegistration = client.service(
    'visitorAppointmentRegistration'
  );
  const [visitorAppointmentArr, setVisitorAppointmentArr] = useState([]);
  const [visitorAppointmentAllArr, setVisitorAppointmentAllArr] = useState([]);
  const [addTimeDialog, setAddTimeDialog] = useState(false);
  const [openTimeStatus, setOpenTimeStatus] = useState(false);
  const [carNumber, setCarNumber] = useState('');
  const [reservationTimeStart, setReservationTimeStart] = useState('');
  const [count, setCount] = useState(0);
  const [minute, setMinute] = useState(0);

  // sort
  const [curdataIndex, setcurDataIndex] = useState('householdNumber');
  const [curorder, setcurOrder] = useState('asc');

  // 抓入場車牌
  async function funFindVisitor() {
    const result = await visitorAppointmentRegistration.find({
      query: {
        $or: [
          // 篩選已入場或是預約中的訪客
          {
            visitorsStatus: { $in: ['已入場'] },
          },
          {
            $and: [
              // 只顯示預約中且三天內預約的訪客的訪客
              { visitorsStatus: { $in: ['預約中'] } },
              {
                reservationTimeStart: {
                  $gte: Number(
                    // 搜尋預約時間大於等於從今天00：00分開始往前兩天的記錄
                    new Date(
                      moment()
                        .startOf('day')
                        .subtract(2, 'days')
                        .format('YYYY-MM-DD HH:mm:ss')
                    )
                  ),
                },
              },
            ],
          },
        ],
        $sort: { reservationTimeStart: 1 },
      },
    });
    return result && result.data ? result.data : [];
  }

  const serverVisitorDataUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    funFindVisitor().then((result) => {
      setVisitorAppointmentArr(
        result
          .filter((x) => x.carNumber !== '')
          .sort((a, b) => {
            const result = (
              typeof a[rdataIndex] === 'number'
                ? a[rdataIndex].toString()
                : a[rdataIndex]
            ).localeCompare(
              typeof b[rdataIndex] === 'number'
                ? b[rdataIndex].toString()
                : b[rdataIndex]
            );
            return rorder === 'asc'
              ? result > 0
                ? 1
                : -1
              : result > 0
              ? -1
              : 1;
          })
      );

      setVisitorAppointmentAllArr(
        result
          .filter((x) => x.carNumber !== '')
          .sort((a, b) => {
            const result = (
              typeof a[rdataIndex] === 'number'
                ? a[rdataIndex].toString()
                : a[rdataIndex]
            ).localeCompare(
              typeof b[rdataIndex] === 'number'
                ? b[rdataIndex].toString()
                : b[rdataIndex]
            );
            return rorder === 'asc'
              ? result > 0
                ? 1
                : -1
              : result > 0
              ? -1
              : 1;
          })
      );
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverVisitorDataUpdate(dataIndex, order);
  };
  useEffect(() => {
    serverVisitorDataUpdate();
  }, []);

  function searchRender(value) {
    // input search filter
    if (value.length > 0) {
      const sortedArr = [...visitorAppointmentAllArr]
        .map((e) => {
          let hasIncludes = false;
          Object.keys(e).forEach((ee) => {
            const val2 = e[ee];

            if (val2 !== null) {
              if (val2.toString().includes(value)) hasIncludes = true;
            }
          });
          if (hasIncludes) return e;
          return false;
        })
        .filter((e) => e !== false);

      setVisitorAppointmentArr([...sortedArr]);
    } else {
      setVisitorAppointmentArr([...visitorAppointmentAllArr]);
    }
  }

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = visitorAppointmentArr.slice(
    indexOfFirstPost,
    indexOfLastPost
  );
  console.log(currentPosts);

  return (
    <>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addTimeDialog}
        onOk={() => {
          const carArr = currentPosts.filter((x) => x.carNumber === carNumber);
          if (carArr && carArr.length > 0) {
            // 20220310 修改顯示欄位及加時
            Swal.fire({
              title: `確定新增車牌(${carNumber})時間?`,
              text: `加時:${(
                parseInt(
                  count * 1000 * 60 * 60 +
                    parseInt(moment(minute).format('mm')) * 1000 * 60
                ) /
                1000 /
                60 /
                60
              ).toFixed(2)}小時`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                axios('/ezcon/api/ba/visitorCarAddTime', {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: {
                    carNumber,
                    reservationTimeStart,
                    time:
                      count * 1000 * 60 * 60 +
                      parseInt(moment(minute).format('mm')) * 1000 * 60,
                  },
                })
                  .then((res) => {
                    console.log('==carNumber update success:', res);

                    setCount(0);
                    setMinute(0);
                    setCarNumber('');
                    setReservationTimeStart('');
                    serverVisitorDataUpdate();
                    setAddTimeDialog(false);
                    setOpenTimeStatus(false);
                    Swal.fire('成功!', '此車牌加時成功', 'success');
                  })
                  .catch((error) => {
                    console.log('==carNumber update fail:', error);
                    Message.error(`${error}`);
                  });
              }
            });
          } else {
            Message.error('查無此車牌');
            setAddTimeDialog(true);
            setOpenTimeStatus(false);
          }
        }}
        onCancel={() => {
          setCount(0);
          setMinute(0);
          setCarNumber('');
          setReservationTimeStart('');
          setAddTimeDialog(false);
          setOpenTimeStatus(false);
        }}
        onClose={() => {
          setCount(0);
          setMinute(0);
          setCarNumber('');
          setReservationTimeStart('');
          setAddTimeDialog(false);
          setOpenTimeStatus(false);
        }}
      >
        <h2>新增車牌時效</h2>
        <Form.Item label="車牌">
          <Input
            disabled={openTimeStatus !== true}
            value={carNumber}
            name="carNumber"
            placeholder="請輸入車牌"
            onChange={(value) => {
              setCarNumber(value);
            }}
          />
        </Form.Item>
        <Form.Item label="請輸入欲加時間">
          <div className={styles.time}>
            <NumberPicker
              min={0}
              value={count}
              onChange={(value) => {
                if (value) {
                  setCount(value);
                } else {
                  setCount(0);
                }
              }}
            />
            <p>小時</p>
            <TimePicker
              placeholder="請選擇時間"
              format="mm"
              value={minute}
              onChange={(value) => {
                if (value) {
                  setMinute(value);
                } else {
                  setMinute(0);
                }
              }}
            />
            <p>分鐘</p>
          </div>
        </Form.Item>
      </Dialog>

      <div className={styles.btnBox}>
        {/* 20220310 拿掉一鍵車牌加時 */}
        {/* <Button
          className={styles.addBtn}
          type="normal"
          onClick={() => {
            setAddTimeDialog(true);
            setOpenTimeStatus(true);
          }}
        >
          車牌加時
        </Button> */}
        {/* filter搜尋 */}
        <Input
          className={styles.input}
          size="large"
          placeholder="輸入搜尋文字"
          onChange={searchRender}
          aria-label="this is input"
        />
      </div>
      <Card free>
        <Card.Content>
          <Table dataSource={currentPosts} onSort={onTableSort}>
            {/* <Table.Column
              title="流水號"
              width={100}
              lock='left'
              cell={(value, index, record) => {
                return (
                  index
                )
              }} /> */}
            <Table.Column
              title="預約時間"
              dataIndex="reservationTimeStart"
              sortable
              width={200}
              cell={(_value, _index, record) => {
                return (
                  <>
                    {moment(record.reservationTimeStart).format(
                      'YYYY-MM-DD HH:mm:ss'
                    )}
                  </>
                  // <>{new Date(record.reservationTimeStart).toLocaleString()}</>
                );
              }}
            />
            <Table.Column
              title="來訪時間"
              dataIndex="carEntryTime"
              width={200}
              cell={(_value, _index, record) => {
                const { faceEntryTime, carEntryTime, admissionTime } = record;
                if (carEntryTime) {
                  return moment(carEntryTime).format('YYYY-MM-DD HH:mm:ss');
                } else {
                  const otherEntryTimes = [faceEntryTime, admissionTime];
                  const visitorEntryTime = getVisitorEntryTime(otherEntryTimes);
                  return visitorEntryTime;
                }
              }}
            />
            <Table.Column
              title="訪客姓名"
              dataIndex="visitorsName"
              width={130}
            />
            <Table.Column
              title="受訪人戶號"
              dataIndex="householdNumber"
              sortable
              width={130}
            />
            <Table.Column
              title="人數"
              dataIndex="peopleNumber"
              sortable
              width={130}
            />
            <Table.Column
              title="車牌"
              dataIndex="carNumber"
              sortable
              width={130}
              cell={(_value, index) => {
                return (
                  <>
                    {currentPosts[index].carNumber
                      ? currentPosts[index].carNumber
                      : '無'}
                  </>
                );
              }}
            />
            {/* 20220317 增加車牌時效加時按鈕 */}
            <Table.Column
              title="車牌時效"
              dataIndex="carEndTime"
              width={211}
              cell={(_value, _index, record) => {
                return (
                  <>
                    {/* 確認是否有carEndTime */}
                    {Object.hasOwnProperty.call(record, 'carEndTime') ? (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {moment(record.carEndTime).format(
                          'YYYY-MM-DD HH:mm:ss'
                        )}
                        {/* 確認是否過期 */}
                        {new Date(record.carEndTime) < new Date() && '(已過期)'}
                      </div>
                    ) : (
                      '無'
                    )}
                  </>
                );
              }}
            />
            <Table.Column
              title="操作"
              lock="right"
              width={131}
              cell={(_value, _index, record) => {
                return (
                  <Box style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      type="secondary"
                      onClick={() => {
                        // alert(record.carNumber)
                        setAddTimeDialog(true);
                        setCarNumber(record.carNumber);
                        setReservationTimeStart(record.reservationTimeStart);
                      }}
                    >
                      車牌加時
                    </Button>
                  </Box>
                );
              }}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={visitorAppointmentArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default VisitorAccessStatisticsList;
